const gridSelector = [
  '[data-testid="product-grid"]',
  '[data-testid="resource-list-grid"]',
  '#predictive-search-products .predictive-search-results__list',
  '.kr-products',
].join(',');
const cardSelector = [
  ':scope > .product-grid__item:not([data-kr-rotated])',
  ':scope > .resource-list__item:not([data-kr-rotated])',
  ':scope > .predictive-search-results__card--product:not([data-kr-rotated])',
  ':scope > .kr-card:not([data-kr-rotated])',
].join(',');

function randomIndex(maximum) {
  if (maximum < 2) return 0;

  const values = new Uint32Array(1);
  crypto.getRandomValues(values);
  return values[0] % maximum;
}

function productKey(card) {
  return (
    card.dataset.productId ||
    card.querySelector('[data-product-id]')?.dataset.productId ||
    card.querySelector('a[href*="/products/"]')?.getAttribute('href') ||
    ''
  );
}

function storageKey(grid, page) {
  const grids = [...document.querySelectorAll(gridSelector)];
  const gridIndex = grids.indexOf(grid);
  const query = new URL(window.location.href).searchParams.get('q') || '';
  return `kr-first-product:${window.location.pathname}:${query}:${gridIndex}:${page}`;
}

function rotateGrid(grid) {
  if (new URL(window.location.href).searchParams.has('sort_by')) return;

  const cardsByPage = new Map();

  for (const card of grid.querySelectorAll(cardSelector)) {
    card.dataset.krRotated = 'true';
    const page = card.dataset.page || '1';
    const cards = cardsByPage.get(page) || [];
    cards.push(card);
    cardsByPage.set(page, cards);
  }

  for (const [page, cards] of cardsByPage) {
    if (cards.length < 2) continue;

    const key = storageKey(grid, page);
    const previousFirst = sessionStorage.getItem(key);
    const availableOffsets = cards
      .map((card, index) => ({ index, key: productKey(card) }))
      .filter((candidate) => candidate.key !== previousFirst && (previousFirst || candidate.index !== 0));
    const candidates = availableOffsets.length > 0 ? availableOffsets : cards.map((card, index) => ({ index }));
    const offset = candidates[randomIndex(candidates.length)].index;
    const rotatedCards = cards.slice(offset).concat(cards.slice(0, offset));
    grid.append(...rotatedCards);
    sessionStorage.setItem(key, productKey(rotatedCards[0]));
  }
}

function rotateGrids(root) {
  if (!(root instanceof Element || root instanceof DocumentFragment)) return;

  if (root instanceof Element && root.matches(gridSelector)) rotateGrid(root);
  for (const grid of root.querySelectorAll(gridSelector)) rotateGrid(grid);
}

function initializeProductRotation() {
  rotateGrids(document.body);

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      const grid = mutation.target instanceof Element ? mutation.target.closest(gridSelector) : null;
      if (grid) rotateGrid(grid);

      for (const node of mutation.addedNodes) rotateGrids(node);
    }
  }).observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeProductRotation, { once: true });
} else {
  initializeProductRotation();
}